const ONE_MB_IN_BYTES: number = 1024 * 1024;

export const FILE_ATTACHMENT_TYPE: string = 'FileAttachment:#Exchange';
export const ITEM_ATTACHMENT_TYPE: string = 'ItemAttachment:#Exchange';
export const ITEM_ID_ATTACHMENT_TYPE: string = 'ItemIdAttachment:#Exchange';
export const REFERENCE_ATTACHMENT_TYPE: string = 'ReferenceAttachment:#Exchange';

export const MAX_SIZE_FOR_GENERATING_THUMBNAIL_IN_BYTES: number = 10 * ONE_MB_IN_BYTES;

export const AttachmentConstants = {
    attachmentTypes: {
        FILE_ATTACHMENT_TYPE: FILE_ATTACHMENT_TYPE,
        ITEM_ATTACHMENT_TYPE: ITEM_ATTACHMENT_TYPE,
        ITEM_ID_ATTACHMENT_TYPE: ITEM_ID_ATTACHMENT_TYPE,
        REFERENCE_ATTACHMENT_TYPE: REFERENCE_ATTACHMENT_TYPE,
    },
};
